export const theme = {
    white:"#ffffff",
    primary:"#aeb8fe",
    content_text: "#ced4da",
    head: "#dee2e6"
}